module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-hyundai-24.d3380c76.jpg";